import { useContext } from 'react';
import { AccessTokenContext, } from './access-token-context';
export var useAccessToken = function () {
    return useContext(AccessTokenContext);
};
